export default __webpack_public_path__ + "static/media/arrow-down.c230d14b.svg";